import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.serviceWorkerEnabled) {
  (async () => {
    const sentry = await import('@sentry/angular-ivy');
    sentry.init({
      environment: environment.production ? 'production' : 'development',
      dsn: environment.sentryDsn,
      integrations: [new sentry.BrowserTracing(), new sentry.Integrations.Breadcrumbs({ console: false })],
      tracesSampleRate: environment.production ? 0.2 : 1
    });
  })();
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
